import "react-circular-progressbar/dist/styles.css";

import {
  hasLabelId,
  isLabelNameSliced,
  newSidebarMenu,
  sidebarFiltersMenu,
  sliceLabelName,
  getAvailablePickerProjectsAmount,
} from "../helpers.js";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import Button from "../../../Elements/Button/Button.js";
import CreateEditLabel from "../Popups/CreateEditLabel.tsx";
import DeleteLabel from "../Popups/DeleteLabel.tsx";
import Icon from "../../../Elements/Icon/Icon.tsx";
import LabelContextMenu from "./LabelContextMenu/LabelContextMenu.tsx";
import LabelIcon from "../Reusable/LabelIcon.tsx";
import Login from "components/Structure/Login/Login.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import Counter from "components/Reusable/Counter/Counter.tsx";
import SubscriptionInfo from "./SubscriptionInfo/index.tsx";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import { LinkToNewTab } from "../../../Elements/Link/Link.js";
import { IconWithTooltip } from "../../../Elements/Icon/Icon.tsx";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import useInbox from "hooks/useInbox.ts";
import { useModal } from "../../../../contexts/modalContext/modalContext.js";
import { usePicker } from "contexts/pickerContext/pickerContext.ts";
import { useUser } from "../../../../contexts/userContext/userContext.js";
import { useAppSelector } from "store/hooks.ts";
import {
  selectFParam,
  selectPickerSearchParams,
  selectSearchParams,
  selectTParam,
} from "store/selectors/inboxSelectors.ts";
import useUrlLink from "./hooks/useUrlLink.ts";
import Image from "components/Elements/Image/Image.tsx";
import useOrganization from "hooks/useOrganization.ts";

const SideMenuItem = ({ sysName, data, setShowSideBar }) => {
  const { getTextByKey, getDirection } = useContent();
  const pageType = useAppSelector(selectTParam);
  const isManageStorage = window.location.pathname.includes("manageStorage");
  const { navigateToNewPageType, getNewPageTypeUrl } = useUrlLink();

  const handleUrlChange = (e) => {
    e.preventDefault();
    navigateToNewPageType(sysName);
    setShowSideBar?.(false);
  };

  return (
    <div className="inbox-menu-item">
      <a
        className={`main-title-container ${
          sysName === pageType && !isManageStorage ? "selected" : ""
        }`}
        href={getNewPageTypeUrl(sysName)}
        onClick={handleUrlChange}
      >
        <Icon
          className={
            data.icon.name === "contact-react-list" ? "contacts-image" : ""
          }
          name={data.icon.name}
          disabledgray={sysName !== "picker"}
          {...data.icon.prop}
          style={{
            transform: `scaleX(${getDirection() === "ltr" ? 1 : -1})`,
          }}
        />
        <div className="item-name">
          {getTextByKey(data.viewNameKey)}{" "}
          {sysName === "received" && (
            <Counter
              counterName="inboxPendingDownload"
              className="received-counter-wrapper"
            />
          )}
        </div>
        <div className="item-count">
          {/* {sysName === "picker"
            ? getPickerMailList().length
            : getMailsCount()?.[sysName]} */}
        </div>
      </a>
    </div>
  );
};

const SideFilterItem = ({ sysName, data, setShowSideBar }) => {
  const { getMailsCount, setPickerSearchParams } = useInbox();
  const { getTextByKey } = useContent();
  const pickerSearchParams = useAppSelector(selectPickerSearchParams);
  const pageType = useAppSelector(selectTParam);
  const pageCategory = useAppSelector(selectFParam);
  const { getPickerMailList, getPickerProjectsCount } = usePicker();
  const { isPro, isBusiness } = useUser();
  const availablePickerProjectsAmount = getAvailablePickerProjectsAmount(
    isPro(),
    isBusiness()
  );
  const pickerProjectsAmount = getPickerProjectsCount();
  const { navigateToNewCategoryType, getCategoryFilterUrl } = useUrlLink();

  const handleUrlChange = (e) => {
    !e.target.href?.includes("plans") && e.preventDefault();
    navigateToNewCategoryType(sysName);
    setShowSideBar?.(false);
  };

  return (
    <div className={`inbox-filter-item`}>
      <a
        className={`main-title-container ${
          (
            sysName === "picker"
              ? sysName === pageType
              : sysName === pageCategory
          )
            ? "selected"
            : ""
        }`}
        href={getCategoryFilterUrl(sysName)}
        onClick={handleUrlChange}
      >
        <Icon name={data.icon.name} xl />
        <div className="item-name">
          {data.name}
          {sysName === "jform" && (
            <Counter
              counterName="jFormsPendingDownload"
              className="received-counter-wrapper"
            />
          )}
        </div>
        <div className="item-count">
          {" "}
          {sysName === "picker"
            ? `${getPickerMailList().length}${
                availablePickerProjectsAmount
                  ? `/${availablePickerProjectsAmount}`
                  : ""
              }`
            : getMailsCount()?.[sysName]}
        </div>
      </a>
      {pageType === "picker" && sysName === "picker" ? (
        <ul className="picker-sub-sections">
          <li className={pickerSearchParams?.p !== "archived" ? "active" : ""}>
            <a
              href={`${window.location.origin}${window.location.pathname}?t=picker&p=active`}
              onClick={(e) => {
                e.preventDefault();
                setPickerSearchParams({ p: "active" });
              }}
            >
              <Icon name="newinbox/picker-active" gray />
              {getTextByKey("active-projects")}
              <span className="item-count">
                {pickerProjectsAmount?.totalActive || 0}
              </span>
            </a>
          </li>
          <li className={pickerSearchParams?.p === "archived" ? "active" : ""}>
            <a
              href={`${window.location.origin}${window.location.pathname}?t=picker&p=archived`}
              onClick={(e) => {
                e.preventDefault();
                setPickerSearchParams({ p: "archived" });
              }}
            >
              <Icon name="newinbox/picker-archive" gray />
              {getTextByKey("archived-projects")}
              <span className="item-count">
                {pickerProjectsAmount?.totalArchive || 0}
              </span>
            </a>
          </li>
        </ul>
      ) : null}
    </div>
  );
};

const InboxSideBar = ({ setShowSideBar }) => {
  const { getUserData, isLoggedIn } = useUser();
  const { getMailsCount, setSplitView } = useInbox();
  const { getTextByKey } = useContent();
  const { setModal } = useModal();
  const { setSelectedMail, getLabels, setSearchParams } = useInbox();
  const searchParams = useAppSelector(selectSearchParams);
  const pageType = useAppSelector(selectTParam);
  const [shownLabelContextMenuIndex, setShownLabelContextMenuIndex] =
    useState(-1);
  const { desktopCondition, tabletCondition, mobileCondition } =
    useMediaQueries();
  const [showCreateLabelPopup, setShowCreateLabelPopup] = useState(false);
  const { logo, fetchLogo, checkCurrDomainIsOrgDomain } = useOrganization();

  useEffect(() => {
    fetchLogo();
  }, []);

  const sideBarRef = useRef(null);

  useOnClickOutside(sideBarRef, () => {
    if (!desktopCondition && setShowSideBar) {
      setShowSideBar(false);
    }
  });

  useEffect(() => {
    // remove data from split view if category changed
    setSelectedMail(null);

    if (pageType === "picker") {
      setSplitView(false);
    }
  }, [pageType]);

  const handleCreateLabel = () => {
    if (!isLoggedIn()) {
      setModal({
        modal: Login,
        modalSize: "full-modal",
      });
    } else {
      if (desktopCondition || tabletCondition) {
        setModal({
          modal: CreateEditLabel,
          props: {},
        });
      } else {
        setShowCreateLabelPopup(true);
      }
    }
  };

  const handleEditLabel = useCallback(
    (labelItem) => {
      setShownLabelContextMenuIndex(-1);

      if (desktopCondition || tabletCondition) {
        setModal({
          modal: CreateEditLabel,
          props: {
            labelItem,
          },
        });
      } else {
        setModal({});
        setShowCreateLabelPopup(labelItem);
      }
    },
    [desktopCondition, tabletCondition, CreateEditLabel]
  );

  const handleDeleteLabel = useCallback(
    (labelItem) => {
      if (mobileCondition) {
        setShownLabelContextMenuIndex(-1);
      } else {
        setModal({
          modal: DeleteLabel,
          props: {
            labelItem,
            labeledMailsCount: getMailsCount().labels?.[labelItem.id] || 0,
          },
        });
      }
    },
    [mobileCondition, DeleteLabel, getMailsCount]
  );

  const handleSelectLabel = (newValue) => {
    const prevValue = searchParams.l;

    if (!prevValue) {
      setSearchParams({ l: newValue });
      return;
    }

    if (prevValue.includes(newValue)) {
      setSearchParams({
        l: prevValue.filter((value) => value !== newValue),
      });
    } else {
      setSearchParams({ l: [...prevValue, newValue] });
    }
  };

  const handleLabelActionsClick = (i) => {
    setShownLabelContextMenuIndex(i);
  };

  const labelContextMenuRenderRoot = useMemo(
    () => document.getElementById("inbox-menu"),
    [getLabels()]
  );

  return (
    <>
      <CreateEditLabel
        showPopup={showCreateLabelPopup}
        setShowPopup={setShowCreateLabelPopup}
        labelItem={
          showCreateLabelPopup?.name ? showCreateLabelPopup : undefined
        }
      />
      {/* <div className="expand-sidebar-icon">
        <Icon name="arrow-down" iconClass="arrow-down-icon" gray />
      </div> */}
      <div className="inbox-sidebar" id="inbox-sidebar" ref={sideBarRef}>
        {setShowSideBar ? (
          <div className="sidebar-close-button">
            <Button onClick={() => setShowSideBar(false)} close>
              <Icon large name="x" gray></Icon>
            </Button>
          </div>
        ) : null}
        {(desktopCondition || tabletCondition) && (
          <div className="logo">
            <LinkToNewTab exact page={"home"}>
              {logo && checkCurrDomainIsOrgDomain() ? (
                <Image src={logo} className="custom-logo" />
              ) : null}
              {checkCurrDomainIsOrgDomain() ? null : (
                <Image
                  name="jumbomail-logo-black"
                  alt="JUMBOmail"
                  title="JUMBOmail"
                />
              )}
            </LinkToNewTab>
          </div>
        )}
        <div className="inbox-menu" id="inbox-menu">
          {Object.keys(newSidebarMenu).map((item) => (
            <SideMenuItem
              sysName={item}
              data={newSidebarMenu[item]}
              key={item}
              setShowSideBar={setShowSideBar}
            />
          ))}
          <div className="divider" />
          <h3 className="section-title">{getTextByKey("inbox-filter-by")}</h3>
          {Object.keys(sidebarFiltersMenu)
            .filter((item) =>
              (getUserData()?.HideJumboPicker && item === "picker") ||
              (getUserData()?.HideJumboPay && item === "jpay") ||
              getUserData()?.HideJumboPicker === undefined
                ? false
                : true
            )
            .map((item) => {
              return (
                <SideFilterItem
                  data={sidebarFiltersMenu[item]}
                  key={item}
                  sysName={item}
                  setShowSideBar={setShowSideBar}
                />
              );
            })}
          <div className="divider" />
          {pageType !== "picker" && (
            <>
              <div className="label-section-title label-feature">
                <h3 className="section-title label-feature">
                  {getTextByKey("inbox-labels")}
                </h3>
                <div className="create-label-icon label-feature">
                  <IconWithTooltip
                    iconProps={{
                      name: "add",
                      gray: true,
                      small: true,
                      onClick: handleCreateLabel,
                    }}
                    tooltipProps={{ tooltipTextKey: "create-label" }}
                  />
                </div>
              </div>
              <div className="labels-container label-feature">
                {!!getLabels() &&
                  Object.keys(getLabels())?.map((item, i) => {
                    return (
                      <div
                        key={item}
                        className={`label-feature label-item ${
                          hasLabelId(searchParams?.l, item)
                            ? "selected-label-item"
                            : ""
                        }`}
                        onMouseLeave={() => setShownLabelContextMenuIndex(-1)}
                        onClick={() => handleSelectLabel(item)}
                      >
                        <LabelIcon color={getLabels()[item].color} />
                        {isLabelNameSliced(getLabels()[item].name) ? (
                          <span>
                            <Tooltip
                              id={getLabels()[item].name}
                              tooltipText={getLabels()[item].name}
                            >
                              {sliceLabelName(getLabels()[item].name)}
                            </Tooltip>
                          </span>
                        ) : (
                          <span>{sliceLabelName(getLabels()[item].name)}</span>
                        )}
                        <span className="spacer" />
                        <span className="item-count">
                          {[getMailsCount()?.labels?.[getLabels()[item].id]]}
                        </span>
                        <div
                          className="dots-vertical"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="icon-wrapper" id={`dots-icon-${i}`}>
                            <Icon
                              name="dots-vertical"
                              onClick={() => handleLabelActionsClick(i)}
                              gray
                            />
                          </div>
                          {shownLabelContextMenuIndex === i && (
                            <LabelContextMenu
                              menuItemIndex={i}
                              onLabelDelete={() =>
                                handleDeleteLabel(getLabels()[item])
                              }
                              onLabelEdit={() =>
                                handleEditLabel(getLabels()[item])
                              }
                              renderRoot={labelContextMenuRenderRoot}
                            />
                          )}
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className="divider label-feature" />
            </>
          )}
          <SubscriptionInfo />
        </div>
      </div>
    </>
  );
};

export default InboxSideBar;
